const viteEnv = import.meta.env;

const enumValue = (value, allowedValues, fallback) => {
  return allowedValues.includes(value) ? value : fallback;
}

export const appConfig = {
  appEnv: viteEnv.VITE_APP_ENV || viteEnv.MODE || 'development',
  authMode: enumValue(viteEnv.VITE_AUTH_MODE, ['single', 'login'], 'single'),
  // 浏览器统一请求同源 /api —— 后端不对外暴露，浏览器永远只跟前端域名打交道。
  // 代理由 dev server（Vite）或生产 Express（server/index.js）转发到后端。
  apiBaseUrl: '/api',
  singleUser: {
    id: viteEnv.VITE_SINGLE_USER_ID || 'local-single-user',
    name: viteEnv.VITE_SINGLE_USER_NAME || 'Howie',
  },
  // 权益门禁元数据（按权益键）。购买链接是数据放配置，文案在 i18n。详见 docs/entitlement-gate.md。
  entitlements: {
    neican: { purchaseUrl: viteEnv.VITE_NEICAN_PURCHASE_URL || '' },
  },
  // 统计埋点：GA4 测量 ID（G-XXXXXXXXXX）。留空则不加载 GA、不发事件。
  analytics: {
    gaId: viteEnv.VITE_GA_ID || '',
  },
  // Casdoor 个人页地址不在这里配：由后端 /auth/me 按 CASDOOR_ENDPOINT 下发（authState.casdoorAccountUrl），
  // 前后端共用同一真相源。
};

export const isSingleUserMode = () => {
  return appConfig.authMode === 'single';
};
